import { pickCommands } from './picking.ts';
import { recoveryPrefix,type RecoveryStorage } from '../browser-recovery/storage.ts';
type Account={userId:string;organizationId:string;domain:string};
type Entry={client:ReturnType<typeof pickCommands>;current:()=>boolean};
// Retain one pending controller per account/item while its screen is closed.
// Its update-protection handle is released by that same controller on receipt.
export function pickCommandCache() {
 const entries=new Map<string,Entry>();
 return {
  get(base:string,account:Account,listId:number,itemId:number,current:()=>boolean,begin?:()=>()=>void,storage?:RecoveryStorage) {
   const key=recoveryPrefix(`preparation-pick-${listId}-${itemId}`,base,account);let entry=entries.get(key);
   if(!entry){entry={current,client:null as unknown as ReturnType<typeof pickCommands>};const owner=entry;entry.client=pickCommands(base,account,listId,itemId,storage,()=>owner.current(),begin);entries.set(key,entry);}
   entry.current=current;const selected=entry;
   return {client:entry.client,activate:()=>{entries.set(key,selected);selected.current=current;},release:()=>{if(selected.current!==current)return;selected.current=()=>false;const state=selected.client.snapshot();if(!state.pending&&!state.busy&&!state.blocked)entries.delete(key);}};
  },
  refresh:()=>entries.forEach(entry=>entry.client.refreshSaved()),
 };
}
